const SORTS = {
    CHRONOLOGICAL: 'CHRONOLOGICAL',
    TITLE: 'TITLE',
    NONE: 'NONE'
}

export default SORTS;